import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'Confirmar dirección de correo',
  [OnboardingStep.StoreDetails]: 'Datos del establecimiento',
  [OnboardingStep.BusinessInfo]: 'Datos de la empresa',
  // Outside Germany, where Store details and Business details are still one step.
  store_and_business_info: 'Añade los datos de tu tienda',
  [OnboardingStep.PersonalInfo]: 'Añade tu información personal',
  // In Germany: the person who signs the contract, for a GmbH its managing director (Nishita).
  owner_personal_info: 'Información personal del propietario',
  owner_personal_info_gmbh: 'Información personal del propietario / director general',
  [OnboardingStep.ShippingInfo]: 'Añade tu información de entrega',
  [OnboardingStep.BankInfo]: 'Añade datos bancarios para cobros',
  [OnboardingStep.TaxInfo]: '¿Tu negocio está registrado en el IVA?',
  [OnboardingStep.BusinessDocs]: 'Documento acreditativo del negocio',
  [OnboardingStep.PersonalDocs]: 'Documento acreditativo de identidad',
  [OnboardingStep.InfoSubmission]: 'Recibir pagos',
  confirm_info_gateway: 'Recibir pagos – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Información de pago',
  [OnboardingStep.Subscription]: 'Suscripción',
  [OnboardingStep.MobileApp]: 'Aplicación móvil',
  [OnboardingStep.DeliveryStructure]: 'Estructura de entrega',
  [OnboardingStep.Contract]: 'Contrato',
  [OnboardingStep.ContractPayment]: 'Pago del contrato',
  [OnboardingStep.Documents]: 'Subir documentos',
  [OnboardingStep.PromoCode]: 'Código promocional',
};
